import capitalize from 'lodash/capitalize'
import every from 'lodash/every'

export default function getProjectStatusForProjectsList(statuses: string[]): [string, string] {
  let projectStatusClass = 'done'
  if (every(statuses, status => status === 'waiting_for_original')) {
    projectStatusClass = 'awaiting_original'
  } else if (every(statuses, status => status === 'new')) {
    projectStatusClass = 'new'
  } else if (!every(statuses, status => status === 'done')){
    projectStatusClass = 'in_progress'
  }

  const projectStatusToRender = capitalize(projectStatusClass.replace('_', ' '))

  return [projectStatusClass, projectStatusToRender]
}
